import React from "react";
import PropTypes from "prop-types";

const LoaderRows = ({ rows }) =>
  rows.map((el, elIx) => (
    <div
      style={{ width: `${el}%` }}
      key={elIx}
      className="flex tl fw5 f3 dib mt2"
    >
      <div className="shimmer h2 w-100" />
    </div>
  ));

LoaderRows.propTypes = {
  rows: PropTypes.array
};

LoaderRows.defaultProps = {
  rows: [45, 23, 60, 48, 87, 90]
};

export default LoaderRows;
